import ExamApplicationModel from '@/dex-shared/models/ExamApplicationModel';

export default {
  examApplicationById: (state: any, getters: any) => (
    examApplicationId: number,
  ) => {
    const examApplication = state.exam_applications[examApplicationId];
    if (examApplication) {
      return new ExamApplicationModel(examApplication, getters);
    } else {
      return {};
    }
  },
};
